export default "__VITE_ASSET__fcenFVft__"